import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart, ArrowLeft } from "lucide-react";
import { useAppMode } from "@/context/AppModeContext";
import { useLocale } from "@/i18n/LocaleContext";

const SECTIONS = [
  ["s1t", ["s1p1"]],
  ["s2t", ["s2p1"]],
  ["s3t", ["s3p1", "s3p2"]],
  ["s4t", ["s4p1", "s4p2", "s4p3"]],
  ["s5t", ["s5p1", "s5p2"]],
  ["s6t", ["s6p1", "s6p2", "s6p3"]],
  ["s7t", ["s7p1", "s7p2"]],
  ["s8t", ["s8p1"]],
  ["s9t", ["s9p1"]],
  ["s10t", ["s10p1"]],
  ["s11t", ["s11p1", "s11p2"]],
  ["s12t", ["s12p1"]],
  ["s13t", ["s13p1"]],
  ["s14t", ["s14p1"]],
];

export default function Terms() {
  const navigate = useNavigate();
  const { isDluxe, appName } = useAppMode();
  const { t } = useLocale();

  return (
    <div className="min-h-screen bg-background" data-testid="terms-page">
      <nav className="flex items-center justify-between px-6 py-4 md:px-12 border-b border-white/5">
        <div className="flex items-center gap-2 cursor-pointer" onClick={() => navigate("/")}>
          {isDluxe ? (
            <img src="/logo-dluxe.png" alt="DLuxe-meet.com" className="h-8 w-auto" data-testid="terms-dluxe-logo" />
          ) : (
            <>
              <Heart className="w-7 h-7 text-primary fill-primary" />
              <span className="text-xl font-bold font-['Outfit'] tracking-tight">{appName}</span>
            </>
          )}
        </div>
        <Button variant="ghost" className="text-muted-foreground" onClick={() => navigate(-1)} data-testid="terms-back-btn">
          <ArrowLeft className="w-4 h-4 mr-2" /> {t("terms.back")}
        </Button>
      </nav>

      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="text-3xl md:text-4xl font-bold font-['Outfit'] tracking-tight mb-2">
          {t("terms.title")}
        </h1>
        <p className="text-sm text-muted-foreground mb-10">{t("terms.updated")}</p>

        {SECTIONS.map(([titleKey, paragraphKeys]) => (
          <section className="mb-8" key={titleKey} data-testid={`terms-section-${titleKey}`}>
            <h2 className="text-lg font-semibold font-['Outfit'] mb-3 text-primary">{t(`terms.${titleKey}`)}</h2>
            <div className="text-sm text-muted-foreground leading-relaxed space-y-3">
              {paragraphKeys.map((pk) => (
                <p key={pk}>{t(`terms.${pk}`)}</p>
              ))}
            </div>
          </section>
        ))}

        <section className="mb-8" data-testid="terms-contact-section">
          <h2 className="text-lg font-semibold font-['Outfit'] mb-3 text-primary">{t("terms.contactT")}</h2>
          <div className="text-sm text-muted-foreground leading-relaxed space-y-3">
            <p>{t("terms.contactP")}</p>
            <p>
              <a href="mailto:contact@luxe-meet.com" className="text-primary hover:underline" data-testid="terms-contact-email">contact@luxe-meet.com</a>
              <br />
              <a href="tel:+17343302395" className="text-primary hover:underline" data-testid="terms-contact-phone">(734) 330-2395</a>
            </p>
          </div>
        </section>

        <div className="mt-12 pt-8 border-t border-white/10 text-center text-sm text-muted-foreground">
          {t("terms.footer")}
        </div>
      </main>
    </div>
  );
}
